import React from "react";

const JQuery_Exercises = () => {
  return (
    <div>
      <h1>JQuery_Exercises</h1>
      <p>Placeholder component for: "JQuery_Exercises"</p>
    </div>
  );
};

export default JQuery_Exercises;
